import { Checkbox } from "../../Checkbox"
import { ResponsiveHorizontalAlign } from "../../../../../base/styles"
import { SelectHorizontalAlign } from "./SelectHorizontalAlign"
import clsx from "clsx"
import { useState } from "react"

export const EditHorizontalAlign = ({ title, value, className, onChange }: {
    title: string,
    value: ResponsiveHorizontalAlign,
    className?: string,
    onChange: (value?: ResponsiveHorizontalAlign) => void
}) => {
    const [responsive, setResponsive] = useState<boolean>();

    return (
        <div className={clsx(className)}>
            <div className="d-flex align-items-end">
                <SelectHorizontalAlign
                    title={title}
                    className="flex-grow-1 pe-2"
                    onChange={(newValue) => { onChange({ ...value, allSizes: newValue }) }}
                    value={value?.allSizes} />
                <Checkbox
                    title="Responsive"
                    className="fs-8 fw-semibold"
                    value={responsive === true}
                    onChange={setResponsive} />
            </div>

            {responsive &&
                <div className="d-flex flex-row flex-wrap mx-5 my-3">
                    <SelectHorizontalAlign
                        title="Small"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, small: newValue }) }}
                        value={value?.small} />
                    <SelectHorizontalAlign
                        title="Medium"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, medium: newValue }) }}
                        value={value?.medium} />
                    <SelectHorizontalAlign
                        title="Large"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, large: newValue }) }}
                        value={value?.large} />
                    <SelectHorizontalAlign
                        title="Ex. Large"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, xLarge: newValue }) }}
                        value={value?.xLarge} />
                    <SelectHorizontalAlign
                        title="Ex. Large +"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, xxLarge: newValue }) }}
                        value={value?.xxLarge} />
                </div>}
        </div>)
}